import clickOutside from "click-outside";

class Header {
  constructor() {
    this.body = document.querySelector("html");
    this.header = document.querySelector("[data-header]");
    this.openToggle = document.querySelector("[data-nav-open]");
    this.closeToggle = document.querySelector("[data-nav-close]");
    this.navigation = document.querySelector("[data-navigation]");
  }

  init() {
    if (this.header && this.openToggle && this.closeToggle && this.navigation) {
      this.addEventListeners();
      this.handleEscapeClick();
      this.handleOutsideClick();
    }
  }

  createEvent = (navigationOpen = false) => {
    const e = new CustomEvent("NavigationStatusChanged", {
      detail: {
        navigationOpen,
      },
    });
    document.dispatchEvent(e);
  };

  handleClick(action) {
    let navigationOpen;

    switch (action) {
      case "OPEN":
        navigationOpen = true;
        this.header.classList.add("is-open");
        this.body.classList.add("header-is-open");
        this.navigation.scrollTop = 0;
        this.createEvent(navigationOpen);
        break;
      case "CLOSE":
        navigationOpen = false;
        this.header.classList.remove("is-open");
        this.body.classList.remove("header-is-open");
        this.createEvent(navigationOpen);
        break;
      default:
        break;
    }
  }

  escapeFunction = () => (event) => {
    if (
      this.body.classList.contains("header-is-open") &&
      event.keyCode === 27
    ) {
      this.handleClick("CLOSE");
    }
  };

  outsideClickFunction = () => (event) => {
    if (!this.openToggle.contains(event.target)) {
      this.handleClick("CLOSE");
    }
  };

  handleOutsideClick = () => {
    clickOutside(this.navigation, this.outsideClickFunction());
  };

  handleEscapeClick = () => {
    document.addEventListener("keydown", this.escapeFunction(), true);
  };

  addEventListeners() {
    this.openToggle.addEventListener("click", () => this.handleClick("OPEN"));
    this.closeToggle.addEventListener("click", () => this.handleClick("CLOSE"));
  }
}

export default Header;
